<template>
    <!--分享-->
  <div id="examshare">
    <h2 class="title">
      <a href="" class="prev"></a>
      邀请好友一起学习
    </h2>
    <!--轮播图-->
    <div class="lbt">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../../assets/img/examshare_lbt_pic1.png" alt="">
            <div class="ewm">
              <div class="left"></div>
              <div class="right">
                <h4>用户54362278</h4>
                <p>推荐你加入育德，扫码领券和知识礼包</p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="../../assets/img/examshare_lbt_pic2.png" alt="">
            <div class="ewm">
              <div class="left"></div>
              <div class="right">
                <h4>用户54362278</h4>
                <p>推荐你加入育德，扫码领券和知识礼包</p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="../../assets/img/examshare_lbt_pic3.png" alt="">
            <div class="ewm">
              <div class="left"></div>
              <div class="right">
                <h4>用户54362278</h4>
                <p>推荐你加入育德，扫码领券和知识礼包</p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="cue">
      <p>
        好友注册后你将获得20元优惠券<br>
        好友也将领取到同等价值优惠券
      </p>
    </div>
    <div class="share">
      <a href="" class="wx">微信</a>
      <a href="" class="pyq">朋友圈</a>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
/* eslint-disable no-new */
export default {
  name: 'ExamShare',
  data () {
    return {

    }
  },
  mounted () {
    new Swiper('.lbt .swiper-container', {
      loop: true,
      pagination: {
        el: '.lbt .swiper-pagination'
      }
    })
  }
}
</script>

<style scoped lang="stylus">
  #examshare
    h2.title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    .lbt
      height: 9rem
      overflow: hidden
      .swiper-container
        width: 6.14rem
        height: 8.48rem
        margin: 0 auto
        overflow: visible
        .swiper-slide
          position: relative
          width: 6.14rem
          padding: 0 .2rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          -webkit-transform: scale(.94)
          -moz-transform: scale(.94)
          -ms-transform: scale(.94)
          -o-transform: scale(.94)
          transform: scale(.94)
          img
            width: 5.74rem
            height: 8.48rem
        .swiper-slide-active
          -webkit-transform: scale(1)
          -moz-transform: scale(1)
          -ms-transform: scale(1)
          -o-transform: scale(1)
          transform: scale(1)
    .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction
      bottom: -.5rem
    .cue
      p
        font-size: .28rem
        color: #A3A9B7
        text-align: center
    .share
      display: flex
      justify-content: space-between
      align-items: flex-end
      width: 2.82rem
      height: 1.14rem
      margin: .3rem auto
      a
        display: block
        width: .78rem
        height: 1.14rem
        background: url(../../assets/icon/examshare_icon_wx.png) no-repeat center .08rem
        -webkit-background-size: .78rem .64rem
        background-size: .78rem .64rem
        padding: .8rem 0 0
        font-size: .24rem
        color: #706E6F
        text-align: center
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &.pyq
          background: url(../../assets/icon/examshare_icon_friend.png) no-repeat center top
          -webkit-background-size: .72rem .72rem
          background-size: .72rem .72rem
    .ewm
      position: absolute
      bottom: 0
      left: 50%
      display: flex
      justify-content: space-between
      align-items: center
      width: 5.74rem
      height: 1.44rem
      background-color: rgba(248,241,231,.83)
      padding: .24rem
      -webkit-border-radius: 0 0 .16rem .16rem
      -moz-border-radius: 0 0 .16rem .16rem
      border-radius: 0 0 .16rem .16rem
      -webkit-transform: translate(-50%, 0)
      -moz-transform: translate(-50%, 0)
      -ms-transform: translate(-50%, 0)
      -o-transform: translate(-50%, 0)
      transform: translate(-50%, 0)
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      .left
        width: .96rem
        height: .96rem
        background: url(../../assets/img/examshare_img_dyh.jpg) no-repeat center #fff
        -webkit-background-size: .85rem
        background-size: .85rem
      .right
        width: 4.14rem
        h4
          font-size: .32rem
          color: #3D3C45
          font-weight: 600
        p
          font-size: .24rem
          color: #666
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamShare.vue